import { g as c, c as A, i as pe } from "./TrackerDataModel-D7fU-Wum.js";
const me = /^LC-(\d+)$/, ge = /^([A-Z]{2,5})\.(\d+)$/;
function qt(e) {
  return typeof e == "string" && ge.test(e.trim());
}
function be(e) {
  return typeof e == "string" && me.test(e.trim());
}
function Z(e) {
  return e.issueKey && !be(e.issueKey) ? e.issueKey : e.localKey ?? void 0;
}
const Ht = "Dotted refs are numbered on this machine only — they will not resolve for anyone else.", Zt = "These items depend on each other, so none of them can become ready until one of the links is removed.";
function Jt(e) {
  return e.type === "relationship" || e.type === "reference";
}
function he(e) {
  const t = Array.isArray(e) ? e : e == null ? [] : [e], r = /* @__PURE__ */ new Map();
  for (const n of t) {
    const i = Te(n);
    i && r.set(i.itemId, i);
  }
  return [...r.values()];
}
function Te(e) {
  if (typeof e == "string") return e ? { itemId: e } : null;
  if (!e || typeof e != "object") return null;
  const t = e, r = typeof t.itemId == "string" ? t.itemId : typeof t.id == "string" ? t.id : "";
  if (!r) return null;
  const n = { itemId: r };
  return typeof t.issueKey == "string" && (n.issueKey = t.issueKey), typeof t.title == "string" && (n.title = t.title), typeof t.trackerType == "string" && (n.trackerType = t.trackerType), typeof t.relationshipTypeKey == "string" && (n.relationshipTypeKey = t.relationshipTypeKey), t.direction === "out" && (n.direction = "out"), t.metadata && typeof t.metadata == "object" && (n.metadata = t.metadata), typeof t.revisionId == "string" && (n.revisionId = t.revisionId), typeof t.serverRevision == "number" && (n.serverRevision = t.serverRevision), n;
}
const ve = [
  "backlog",
  "unstarted",
  "started",
  "done",
  "cancelled"
], J = /* @__PURE__ */ new Set([
  "done",
  "cancelled"
]), Qt = {
  backlog: "Backlog",
  unstarted: "Unstarted",
  started: "Started",
  done: "Done",
  cancelled: "Cancelled"
};
function Se(e) {
  return typeof e == "string" && ve.includes(e);
}
const Ce = {
  // done
  done: "done",
  completed: "done",
  complete: "done",
  closed: "done",
  resolved: "done",
  released: "done",
  shipped: "done",
  implemented: "done",
  decided: "done",
  fixed: "done",
  // cancelled
  cancelled: "cancelled",
  canceled: "cancelled",
  rejected: "cancelled",
  declined: "cancelled",
  abandoned: "cancelled",
  obsolete: "cancelled",
  superseded: "cancelled",
  duplicate: "cancelled",
  "wont-do": "cancelled",
  "wont-fix": "cancelled",
  "won't-do": "cancelled",
  "won't-fix": "cancelled",
  "not-planned": "cancelled",
  // in flight
  "in-progress": "started",
  "in-development": "started",
  "in-review": "started",
  "changes-requested": "started",
  approved: "started",
  blocked: "started",
  active: "started",
  // not begun
  "to-do": "unstarted",
  todo: "unstarted",
  open: "unstarted",
  planned: "unstarted",
  ready: "unstarted",
  "ready-for-development": "unstarted",
  // captured
  draft: "backlog",
  new: "backlog",
  backlog: "backlog",
  proposed: "backlog",
  triage: "backlog"
};
function w(e) {
  return String(e ?? "").trim().toLowerCase();
}
function D(e, t) {
  return e.getTypeModel(t)?.roles?.workflowStatus ?? "status";
}
function I(e, t) {
  const r = e.getTypeModel(t);
  if (!r) return [];
  const n = D(e, t);
  return (r.fields.find((s) => s.name === n)?.options ?? []).map((s) => typeof s == "string" ? { value: s, label: s } : s);
}
function S(e, t, r) {
  const n = w(r);
  if (!n) return "unstarted";
  const i = Q(e, t, n);
  if (i) return i;
  const s = e.getTypeModel(t), a = I(e, t), o = s?.fields.find((y) => y.name === D(e, t)), l = w(
    (typeof o?.default == "string" ? o.default : void 0) ?? a[0]?.value
  );
  return l && l === n ? "unstarted" : "started";
}
function Q(e, t, r) {
  const n = w(r);
  if (!n) return;
  const i = I(e, t).find((s) => w(s.value) === n)?.category;
  return Se(i) ? i : Ce[n];
}
function Ie(e, t, r) {
  return J.has(S(e, t, r));
}
function ke(e, t, r) {
  return S(e, t, r) === "done";
}
function we(e, t, r) {
  return S(e, t, r) === "cancelled";
}
function Ne(e, t, r) {
  const n = new Set(r), i = /* @__PURE__ */ new Set();
  for (const s of t)
    for (const a of I(e, s))
      n.has(S(e, s, a.value)) && i.add(a.value);
  return i;
}
const X = "statusCategory", Ae = "readiness", Xt = ["backlog", "unstarted", "started"];
function en(e) {
  return e === "all" ? null : {
    field: X,
    op: e === "open" ? "not-in" : "in",
    value: [...J]
  };
}
function De(e, t, r) {
  const n = r(D(e, t));
  return S(e, t, typeof n == "string" ? n : void 0);
}
function ee(e, t, r) {
  return I(e, t).find((n) => S(e, t, n.value) === r)?.value;
}
function Ee(e, t) {
  return ee(e, t, "done");
}
const f = {
  getTypeModel: (e) => c.get(e)
};
function tn(e) {
  return D(f, e);
}
function nn(e) {
  return I(
    f,
    e
  );
}
function rn(e, t) {
  return S(f, e, t);
}
function sn(e, t) {
  return Q(
    f,
    e,
    t
  );
}
function Fe(e, t) {
  return Ie(f, e, t);
}
function an(e, t) {
  return ke(f, e, t);
}
function on(e, t) {
  return we(f, e, t);
}
function ln(e, t) {
  return Ne(f, e, t);
}
function Re(e, t) {
  return De(f, e, t);
}
function un(e, t) {
  return ee(f, e, t);
}
function cn(e) {
  return Ee(f, e);
}
const _e = {
  bug: "bug_report",
  task: "check_box",
  plan: "assignment",
  idea: "lightbulb",
  decision: "gavel",
  automation: "auto_mode",
  feature: "rocket_launch"
}, Le = {
  bug: "#dc2626",
  task: "#2563eb",
  plan: "#7c3aed",
  idea: "#ca8a04",
  decision: "#8b5cf6",
  automation: "#60a5fa",
  feature: "#10b981"
};
function Oe(e) {
  return _e[e] ?? "label";
}
function Ve(e) {
  return Le[e] ?? "#6b7280";
}
const N = {
  title: "title",
  workflowStatus: "status",
  priority: "priority",
  assignee: "owner",
  reporter: "reporterEmail",
  tags: "tags",
  startDate: "startDate",
  dueDate: "dueDate",
  progress: "progress",
  // No conventional fallbacks: these roles only apply when a schema declares
  // them explicitly (externalKey names a field; prMergedStatus names a status
  // VALUE and must never be resolved through getFieldByRole).
  externalKey: "",
  prMergedStatus: ""
};
function L(e, t) {
  const r = c.get(e);
  if (r) {
    const n = A(r, t);
    if (n) return n;
  }
  return N[t];
}
function te(e) {
  const t = c.get(e.primaryType ?? "");
  if (t?.sharing !== "team") return "n/a";
  const r = e.fields ?? {}, n = r.share && typeof r.share == "object" ? r.share : null;
  return typeof r.shared == "boolean" || n && (n.status === "team" || n.status === "private" || n.body === "team" || n.body === "private") ? r.shared === !0 || n?.status === "team" || n?.body === "team" ? "published" : "draft" : e.syncStatus === "synced" || e.syncStatus === "pending" ? "published" : t.draftByDefault ? "draft" : "published";
}
function v(e, t) {
  const r = c.get(e.primaryType), n = r ? A(r, t) ?? N[t] : N[t];
  return e.fields[n];
}
function O(e, t, r) {
  return v(e, t) ?? r;
}
function dn(e) {
  return O(e, "title", "");
}
function V(e) {
  return O(e, "workflowStatus", "");
}
function ne(e) {
  return O(e, "priority", "");
}
function fn(e) {
  return e.fields.kanbanSortOrder;
}
function yn(e) {
  const t = c.get(e.primaryType), r = t ? A(t, "externalKey") : void 0;
  if (!r) return "";
  const n = e.fields[r];
  if (n == null) return "";
  if (typeof n == "object") {
    const i = n;
    return typeof i.label == "string" && i.label ? i.label : typeof i.url == "string" ? i.url : "";
  }
  return String(n);
}
function Ke(e, t) {
  const r = c.get(e);
  if (!r) return;
  const n = A(r, t) ?? N[t];
  return r.fields.find((i) => i.name === n);
}
function Me(e) {
  return Ke(e, "workflowStatus")?.options ?? [];
}
const Be = [
  { value: "to-do", label: "To Do" },
  { value: "in-progress", label: "In Progress" },
  { value: "in-review", label: "In Review" },
  { value: "done", label: "Done" }
];
function Ue(e) {
  return e.split("-").map((t) => t && t.charAt(0).toUpperCase() + t.slice(1)).join(" ");
}
function $e(e, t) {
  const r = [], n = /* @__PURE__ */ new Set();
  for (const i of e)
    n.has(i.value) || (n.add(i.value), r.push({ value: i.value, label: i.label }));
  if (r.length === 0)
    for (const i of Be)
      n.add(i.value), r.push(i);
  for (const i of t) {
    const s = (i || "to-do").toLowerCase();
    n.has(s) || (n.add(s), r.push({ value: s, label: Ue(s) }));
  }
  return r;
}
function pn(e, t) {
  const r = e !== "all" ? Me(e) : [], n = t.map((i) => V(i) || "to-do");
  return $e(r, n);
}
function $(e, t) {
  const r = e.toLowerCase();
  return !!(t.email && r === t.email.toLowerCase() || t.displayName && r === t.displayName.toLowerCase() || t.gitEmail && r === t.gitEmail.toLowerCase() || t.gitName && r === t.gitName.toLowerCase());
}
function Pe(e, t) {
  if (!e || !t) return !1;
  const r = (s) => s ? s.trim().toLowerCase() : "", n = [r(e.email), r(e.gitEmail)].filter(Boolean), i = [r(t.email), r(t.gitEmail)].filter(Boolean);
  for (const s of n)
    if (i.includes(s)) return !0;
  if (n.length === 0 && i.length === 0) {
    const s = r(e.displayName), a = r(t.displayName);
    if (s && a && s === a) return !0;
  }
  return !1;
}
function Ge(e, t) {
  const r = v(e, "assignee");
  if (r && $(r, t)) return !0;
  const n = e.fields.assigneeEmail;
  if (n && $(n, t)) return !0;
  const i = e.system.authorIdentity;
  return !!(i?.email && t.email && i.email.toLowerCase() === t.email.toLowerCase() || i?.gitEmail && t.gitEmail && i.gitEmail.toLowerCase() === t.gitEmail.toLowerCase());
}
function mn(e) {
  const t = e.getFullYear(), r = String(e.getMonth() + 1).padStart(2, "0"), n = String(e.getDate()).padStart(2, "0");
  return `${t}-${r}-${n}`;
}
function re(e) {
  if (typeof e != "string") return !1;
  const t = e.trim();
  return /^\d{4}-\d{1,2}-\d{1,2}$/.test(t) || /^\d{4}-\d{1,2}-\d{1,2}T00:00:00(?:\.000)?Z$/.test(t);
}
function je(e) {
  if (e == null) return null;
  if (e instanceof Date) return isNaN(e.getTime()) ? null : e;
  if (typeof e == "number") {
    const s = new Date(e);
    return isNaN(s.getTime()) ? null : s;
  }
  if (typeof e != "string") return null;
  const t = e.trim();
  if (!t) return null;
  const r = t.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:T00:00:00(?:\.\d+)?Z)?$/);
  if (r)
    return new Date(+r[1], +r[2] - 1, +r[3]);
  const n = t.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (n)
    return new Date(+n[3], +n[1] - 1, +n[2]);
  const i = new Date(t);
  return isNaN(i.getTime()) ? null : i;
}
const We = [
  {
    key: "depends-on",
    displayName: "Depends on",
    inverseKey: "blocks",
    inverseDisplayName: "Blocks",
    category: "dependency",
    description: "Work this item is waiting on."
  },
  {
    key: "blocks",
    displayName: "Blocks",
    inverseKey: "depends-on",
    inverseDisplayName: "Depends on",
    category: "dependency",
    description: "Work that is waiting on this item."
  },
  { key: "relates-to", displayName: "Relates to", category: "reference", symmetric: !0 },
  { key: "duplicates", displayName: "Duplicates", category: "reference" },
  { key: "supersedes", displayName: "Supersedes", category: "reference" },
  { key: "parent-of", displayName: "Parent of", inverseKey: "child-of", inverseDisplayName: "Child of", category: "hierarchy" },
  { key: "child-of", displayName: "Child of", inverseKey: "parent-of", inverseDisplayName: "Parent of", category: "hierarchy" },
  // Collection membership: a milestone/release `has-item`, and each member is
  // `in-collection`. Same hierarchy machinery as parent-of/child-of, but a
  // distinct vocabulary so "belongs to a sprint" reads differently from
  // "is a subtask of".
  { key: "has-item", displayName: "Includes", inverseKey: "in-collection", inverseDisplayName: "In collection", category: "hierarchy", icon: "inventory_2" },
  { key: "in-collection", displayName: "In collection", inverseKey: "has-item", inverseDisplayName: "Includes", category: "hierarchy", icon: "inventory_2" },
  { key: "contributes-to", displayName: "Contributes", inverseKey: "contributed-by", inverseDisplayName: "Goal", category: "hierarchy", icon: "flag" },
  { key: "contributed-by", displayName: "Goal", inverseKey: "contributes-to", inverseDisplayName: "Contributes", category: "hierarchy", icon: "flag" }
], Ye = new Map(We.map((e) => [e.key, e]));
function gn(e, t) {
  if (e)
    return t?.find((r) => r.key === e) ?? Ye.get(e);
}
function k(e) {
  return e.type === "relationship" || e.type === "reference";
}
function g(e) {
  return he(e);
}
function bn(e, t, r) {
  const n = [];
  !e.multiValue && t.length > 1 && n.push({ code: "too-many", message: `Field "${e.name}" is single-value but got ${t.length} targets` });
  const i = /* @__PURE__ */ new Set();
  for (const s of t) {
    if (!s.itemId) {
      n.push({ code: "empty-target", message: "Relationship target is missing an itemId" });
      continue;
    }
    if (i.has(s.itemId) && n.push({ code: "duplicate", itemId: s.itemId, message: `Duplicate target ${s.itemId}` }), i.add(s.itemId), s.itemId === r.sourceItemId && !e.allowSelfLink && n.push({ code: "self-link", itemId: s.itemId, message: "An item cannot link to itself on this field" }), e.targetTrackerTypes && e.targetTrackerTypes !== "*") {
      const a = s.trackerType ?? r.targetTypeOf?.(s.itemId);
      a && !e.targetTrackerTypes.includes(a) && n.push({
        code: "target-type",
        itemId: s.itemId,
        message: `Target ${s.itemId} is "${a}", not one of ${e.targetTrackerTypes.join(", ")}`
      });
    }
  }
  return n;
}
function hn(e, t, r) {
  const n = {
    direction: "out",
    ...e.relationshipTypeKey ? { relationshipTypeKey: e.relationshipTypeKey } : {},
    ...r
  };
  return e.multiValue ? [...g(t).filter((s) => s.itemId !== r.itemId), n] : [n];
}
function Tn(e, t) {
  return g(e).filter((r) => r.itemId !== t);
}
function vn(e, t) {
  return e.multiValue ? t : t[0] ?? null;
}
function Sn(e, t, r, n) {
  if (!e.inverseFieldId) return [];
  const i = new Set(g(r).map((l) => l.itemId)), s = new Set(g(n).map((l) => l.itemId)), a = {
    itemId: t.itemId,
    direction: "out",
    ...t.issueKey ? { issueKey: t.issueKey } : {},
    ...t.title ? { title: t.title } : {},
    ...t.trackerType ? { trackerType: t.trackerType } : {},
    ...e.inverseRelationshipTypeKey ? { relationshipTypeKey: e.inverseRelationshipTypeKey } : {}
  }, o = [];
  for (const l of s)
    i.has(l) || o.push({ targetItemId: l, inverseFieldId: e.inverseFieldId, op: "add", value: a });
  for (const l of i)
    s.has(l) || o.push({ targetItemId: l, inverseFieldId: e.inverseFieldId, op: "remove", value: a });
  return o;
}
function Cn(e, t, r) {
  if (!t) return [];
  const n = [];
  for (const i of r) {
    if (!k(i)) continue;
    const s = g(t[i.name]);
    for (const a of s)
      a.itemId && n.push({
        sourceItemId: e,
        sourceFieldId: i.name,
        relationshipTypeKey: a.relationshipTypeKey ?? i.relationshipTypeKey,
        targetItemId: a.itemId,
        targetTrackerType: a.trackerType,
        predicate: i.predicate ?? null,
        metadata: a.metadata
      });
  }
  return n;
}
const ie = /* @__PURE__ */ new Set([
  "type",
  "key",
  "updated",
  "viewed",
  "created",
  "createdBy",
  "updatedBy",
  "archived",
  "module",
  "shared"
]);
function se(e) {
  if (!e || e.readOnly) return { kind: "readonly" };
  switch (e.type) {
    case "text":
      return { kind: "multiline" };
    case "number":
      return { kind: "number", min: e.min, max: e.max };
    case "select":
      return { kind: "select", options: e.options ?? [] };
    case "multiselect":
      return { kind: "multiselect", options: e.options ?? [], multiValue: !0 };
    case "array":
      return { kind: "multiselect", options: e.options ?? [], multiValue: !0 };
    case "date":
      return { kind: "date" };
    case "datetime":
      return { kind: "datetime" };
    case "boolean":
      return { kind: "boolean" };
    case "user":
      return { kind: "user" };
    case "url":
      return { kind: "url" };
    case "relationship":
    case "reference":
      return {
        kind: "relationship",
        multiValue: e.multiValue ?? !1,
        targetTrackerTypes: e.targetTrackerTypes,
        relationshipTypeKey: e.relationshipTypeKey
      };
    case "object":
      return { kind: "readonly" };
    case "citation":
      return { kind: "readonly" };
    default:
      return { kind: "text" };
  }
}
function ze(e) {
  return Array.isArray(e) ? e.map((t) => String(t).trim()).filter((t) => t.length > 0) : typeof e == "string" ? e.split(",").map((t) => t.trim()).filter((t) => t.length > 0) : [];
}
function b(e) {
  return e == null || typeof e == "string" && e.trim() === "";
}
function In(e, t) {
  const r = se(e);
  switch (r.kind) {
    case "number": {
      if (b(t)) return;
      const n = typeof t == "number" ? t : Number(String(t).trim());
      return Number.isFinite(n) ? n : void 0;
    }
    case "boolean": {
      if (typeof t == "boolean") return t;
      if (b(t)) return !1;
      const n = String(t).trim().toLowerCase();
      return n === "true" || n === "1" || n === "yes";
    }
    case "multiselect": {
      const n = ze(t);
      return n.length > 0 ? n : void 0;
    }
    case "date": {
      if (b(t)) return;
      if (t instanceof Date)
        return Number.isNaN(t.getTime()) ? void 0 : t.toISOString().slice(0, 10);
      const n = String(t).trim();
      if (/^\d{4}-\d{2}-\d{2}$/.test(n)) return n;
      const i = new Date(n);
      return Number.isNaN(i.getTime()) ? void 0 : i.toISOString().slice(0, 10);
    }
    case "datetime": {
      if (b(t)) return;
      const n = t instanceof Date ? t : new Date(String(t).trim());
      return Number.isNaN(n.getTime()) ? void 0 : n.toISOString();
    }
    case "url": {
      if (b(t)) return;
      if (typeof t == "object" && t !== null && "url" in t) {
        const n = t;
        return n.url ? n : void 0;
      }
      return { url: String(t).trim() };
    }
    case "relationship": {
      if (b(t)) return [];
      const n = g(t);
      return r.multiValue ? n : n.slice(0, 1);
    }
    case "readonly":
      return;
    default:
      return b(t) ? void 0 : String(t);
  }
}
const ae = "icon";
function kn(e) {
  return e?.typeColumnDisplay === "label" ? "label" : ae;
}
const P = [
  { id: "type", label: "Type", width: 64, minWidth: 64, sortable: !0, render: "type-icon", defaultVisible: !0, builtin: !0, editable: !1, edit: "readonly" },
  // Wide enough for a five-digit key at the grid's 12px, since the key is the
  // row's open affordance and a truncated one cannot be read or aimed at.
  { id: "key", label: "Key", width: 110, minWidth: 90, sortable: !0, render: "text", defaultVisible: !0, sortKey: "issueKey", builtin: !0, editable: !1, edit: "readonly" },
  { id: "updated", label: "Updated", width: 100, sortable: !0, render: "date", defaultVisible: !0, sortKey: "lastIndexed", builtin: !0, editable: !1, edit: "readonly" },
  { id: "viewed", label: "Viewed", width: 100, sortable: !0, render: "date", defaultVisible: !1, builtin: !0, editable: !1, edit: "readonly" },
  { id: "createdBy", label: "Created by", width: 140, minWidth: 100, sortable: !0, render: "avatar", defaultVisible: !1, builtin: !0, editable: !1, edit: "readonly" },
  { id: "updatedBy", label: "Updated by", width: 140, minWidth: 100, sortable: !0, render: "avatar", defaultVisible: !1, builtin: !0, editable: !1, edit: "readonly" },
  { id: "module", label: "Source", width: 150, minWidth: 100, sortable: !0, render: "module", defaultVisible: !1, builtin: !0, editable: !1, edit: "readonly" },
  // Label is the product vocabulary (Draft/Published); the id stays `shared`
  // so saved views and typed `shared:` filter tokens keep resolving.
  { id: "shared", label: "Publication", width: 90, minWidth: 70, sortable: !0, render: "badge", defaultVisible: !1, builtin: !0, editable: !1, edit: "readonly" }
], xe = [
  { id: "title", label: "Title", width: "auto", minWidth: 200, sortable: !0, render: "text", defaultVisible: !0, builtin: !0, role: "title", editable: !0, edit: "text" },
  { id: "status", label: "Status", width: 120, sortable: !0, render: "badge", defaultVisible: !0, builtin: !0, role: "workflowStatus", editable: !0, edit: "select" },
  { id: "priority", label: "Priority", width: 100, sortable: !0, render: "badge", defaultVisible: !0, builtin: !0, role: "priority", editable: !0, edit: "select" },
  { id: "owner", label: "Owner", width: 120, minWidth: 100, sortable: !0, render: "avatar", defaultVisible: !0, builtin: !0, role: "assignee", editable: !0, edit: "user" },
  { id: "dueDate", label: "Due Date", width: 100, sortable: !0, render: "date", defaultVisible: !0, builtin: !0, role: "dueDate", editable: !0, edit: "date" },
  { id: "startDate", label: "Start Date", width: 100, sortable: !0, render: "date", defaultVisible: !1, builtin: !0, role: "startDate", editable: !0, edit: "date" },
  { id: "reporterEmail", label: "Reporter", width: 120, minWidth: 100, sortable: !0, render: "avatar", defaultVisible: !1, builtin: !0, role: "reporter", editable: !0, edit: "user" },
  { id: "tags", label: "Tags", width: 120, sortable: !0, render: "tags", defaultVisible: !1, builtin: !0, role: "tags", editable: !0, edit: "multiselect" },
  { id: "progress", label: "Progress", width: 60, sortable: !0, render: "progress", defaultVisible: !1, builtin: !0, role: "progress", editable: !0, edit: "number" }
];
function qe(e) {
  return e.type === "relationship" || e.type === "reference" || e.type === "citation" ? "relationship" : e.type === "date" || e.type === "datetime" ? "date" : e.type === "array" ? "tags" : e.type === "user" ? "avatar" : e.type === "select" ? "badge" : e.type === "url" ? "url" : e.type === "number" && e.max !== void 0 && e.max <= 100 ? "progress" : "text";
}
function He(e, t) {
  return t === "title" ? "auto" : e.type === "user" || e.type === "select" ? 120 : e.type === "number" ? 60 : e.type === "date" || e.type === "datetime" ? 100 : e.type === "array" ? 120 : e.type === "url" ? 200 : 120;
}
const G = {
  title: 0,
  workflowStatus: 1,
  priority: 2,
  assignee: 3,
  reporter: 4,
  tags: 5,
  progress: 6,
  startDate: 7,
  dueDate: 8
};
function Ze(e) {
  const t = c.get(e);
  if (!t)
    return [...P, ...xe];
  const r = /* @__PURE__ */ new Map();
  if (t.roles)
    for (const [s, a] of Object.entries(t.roles))
      r.set(a, s);
  !t.roles?.title && !r.has("title") && r.set("title", "title");
  const n = [...P], i = /* @__PURE__ */ new Set(["created", "updated", "description"]);
  for (const s of t.fields) {
    if (i.has(s.name)) continue;
    const a = r.get(s.name), o = qe(s), l = He(s, a), y = s.name.replace(/([A-Z])/g, " $1").replace(/^./, (u) => u.toUpperCase()).trim(), p = se(s);
    n.push({
      id: s.name,
      label: y,
      width: l,
      minWidth: a === "title" ? 200 : void 0,
      sortable: !0,
      render: o,
      defaultVisible: a != null || (t.tableView?.defaultColumns?.includes(s.name) ?? !1),
      builtin: a != null,
      role: a,
      editable: p.kind !== "readonly" && !ie.has(s.name),
      edit: p.kind
    });
  }
  return n.push({ id: "created", label: "Created", width: 100, sortable: !0, render: "date", defaultVisible: !1, builtin: !0, editable: !1, edit: "readonly" }), n;
}
function wn(e, t) {
  return t.role ? L(e, t.role) : t.id;
}
function Nn(e) {
  const t = Ze(e), r = ["type", "key"], n = t.filter((s) => s.role && s.defaultVisible).sort((s, a) => (G[s.role] ?? 99) - (G[a.role] ?? 99));
  for (const s of n)
    r.push(s.id);
  r.push("updated");
  const i = c.get(e);
  if (i?.tableView?.defaultColumns) {
    for (const s of i.tableView.defaultColumns)
      if (!r.includes(s)) {
        const a = r.indexOf("updated");
        a >= 0 ? r.splice(a, 0, s) : r.push(s);
      }
  }
  return { visibleColumns: r, columnWidths: {}, typeColumnDisplay: ae };
}
const j = {
  "to-do": "#6b7280",
  "in-progress": "#eab308",
  "in-review": "#8b5cf6",
  done: "#22c55e",
  blocked: "#ef4444"
};
function An(e, t) {
  if (j[e]) return j[e];
  if (t) {
    const r = c.get(t);
    if (r) {
      const n = L(t, "workflowStatus"), i = r.fields.find((s) => s.name === n);
      if (i?.options) {
        const s = i.options.find((a) => a.value === e);
        if (s?.color) return s.color;
      }
    }
  }
  return "#6b7280";
}
function Dn(e) {
  return e && { critical: "#dc2626", high: "#ef4444", medium: "#f59e0b", low: "#6b7280" }[e] || "#6b7280";
}
function En(e) {
  const t = c.get(e);
  return t?.color ? t.color : Ve(e);
}
function Fn(e) {
  const t = c.get(e);
  return t?.icon ? t.icon : Oe(e);
}
function Je(e, t = /* @__PURE__ */ new Date()) {
  if (!e || e.getTime() === 0 || isNaN(e.getTime())) return "";
  const r = t.getTime() - e.getTime(), n = r < 0, i = Math.abs(r), s = Math.floor(i / (1e3 * 60)), a = Math.floor(i / (1e3 * 60 * 60)), o = Math.floor(i / (1e3 * 60 * 60 * 24));
  if (s < 1) return "Just now";
  if (s < 60) return n ? `in ${s}m` : `${s}m ago`;
  if (a < 24) return n ? `in ${a}h` : `${a}h ago`;
  if (o === 1) return n ? "Tomorrow" : "Yesterday";
  if (o < 7) return n ? `in ${o}d` : `${o}d ago`;
  if (o < 30) {
    const l = Math.floor(o / 7);
    return n ? `in ${l}w` : `${l}w ago`;
  }
  return e.toLocaleDateString();
}
function W(e) {
  return new Date(e.getFullYear(), e.getMonth(), e.getDate());
}
function Qe(e) {
  return e === 1 ? "1 day" : `${e} days`;
}
function Xe(e) {
  return e === 1 ? "1 week" : `${e} weeks`;
}
function et(e, t = /* @__PURE__ */ new Date()) {
  if (!e || isNaN(e.getTime())) return "";
  const r = 1e3 * 60 * 60 * 24, n = Math.round(
    (W(e).getTime() - W(t).getTime()) / r
  );
  if (n === 0) return "Today";
  if (n === 1) return "Tomorrow";
  if (n === -1) return "Yesterday";
  const i = Math.abs(n);
  if (i >= 30) return e.toLocaleDateString();
  const s = i < 7 ? Qe(i) : Xe(Math.floor(i / 7));
  return n > 0 ? `in ${s}` : `${s} ago`;
}
function Rn(e, t = /* @__PURE__ */ new Date()) {
  if (e == null || e === "") return { display: "", title: "" };
  const r = je(e);
  return r ? re(e) ? {
    display: et(r, t),
    title: r.toLocaleDateString(void 0, {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric"
    })
  } : {
    display: Je(r, t),
    title: r.toLocaleString(void 0, {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit"
    })
  } : { display: String(e), title: "" };
}
function Y(e) {
  if (!e) return;
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? void 0 : t;
}
function tt(e) {
  const t = Y(e.system.lastIndexed), r = e.system.updatedAt || e.system.createdAt;
  return e.source === "frontmatter" && t && re(r) ? t : Y(r) ?? t;
}
function nt(e, t) {
  switch (t) {
    case "type":
      return e.primaryType;
    case "key":
      return Z(e) ?? "";
    case "updated":
      return tt(e);
    case "viewed":
      return e.fields.viewed;
    case "created":
      return e.system.createdAt;
    case "createdBy":
      return e.system.authorIdentity;
    case "updatedBy":
      return e.system.lastModifiedBy ? e.system.lastModifiedBy : [...e.system.activity ?? []].filter((r) => r.authorIdentity).sort((r, n) => n.timestamp - r.timestamp)[0]?.authorIdentity;
    case "archived":
      return e.archived;
    case "module":
      return e.system.documentPath;
    case "shared":
      return te(e);
    default:
      return rt(t, e.fields[t]);
  }
}
function rt(e, t) {
  if (!t || typeof t != "object" || Array.isArray(t) || !("value" in t)) return t;
  const r = c.getLabelRegistry().properties.find((n) => n.id === e);
  return r && pe(r) ? t.value : t;
}
function _n(e, t) {
  if (!ie.has(t))
    return c.get(e)?.fields.find((r) => r.name === t);
}
function Ln(e) {
  if (!e?.trim()) return "?";
  const t = e.trim().split(/\s+/);
  return t.length >= 2 ? (t[0][0] + t[t.length - 1][0]).toUpperCase() : e.substring(0, 2).toUpperCase();
}
function On(e) {
  let t = 0;
  for (let n = 0; n < e.length; n++)
    t = e.charCodeAt(n) + ((t << 5) - t);
  const r = ["#6366f1", "#8b5cf6", "#ec4899", "#f43f5e", "#f97316", "#eab308", "#22c55e", "#14b8a6", "#06b6d4", "#3b82f6"];
  return r[Math.abs(t) % r.length];
}
const it = "has-item", oe = "in-collection", F = ["milestone", "release"];
function le(e) {
  const t = c.get(e);
  return t ? t.fields.some(
    (r) => k(r) && r.relationshipTypeKey === it
  ) : F.includes(e);
}
function st(e) {
  return c.get(e)?.fields.find((t) => k(t) && t.relationshipTypeKey === oe);
}
function Vn(e) {
  if (!k(e)) return !1;
  if (e.relationshipTypeKey === oe) return !0;
  const t = e.targetTrackerTypes;
  return !t || t === "*" || t.length === 0 ? !1 : t.every(le);
}
function Kn(e) {
  const t = e.targetTrackerTypes;
  if (!t || t === "*") return [...F];
  const r = t.filter(le);
  return r.length > 0 ? r : [...F];
}
function Mn(e) {
  const t = c.get(e);
  return {
    label: t?.displayName ?? e.charAt(0).toUpperCase() + e.slice(1),
    icon: t?.icon ?? "inventory_2"
  };
}
const at = [
  "status",
  "priority",
  "assignee",
  "type",
  "tag",
  "milestone",
  "goal"
], Bn = [
  { value: "status", label: "Status" },
  { value: "priority", label: "Priority" },
  { value: "assignee", label: "Assignee" },
  { value: "type", label: "Type" },
  { value: "tag", label: "Tag" },
  { value: "milestone", label: "Milestone" },
  { value: "goal", label: "Goal" }
];
function ot(e) {
  return e.split(/[-_]/).map((t) => t && t[0].toUpperCase() + t.slice(1)).join(" ");
}
function lt(e, t = !1) {
  const r = c.get(e);
  return r ? t && r.displayNamePlural || r.displayName : e;
}
function K(e, t) {
  const r = typeof e == "string" ? e : `field:${e.fieldId}`;
  return t === null ? `${r}:empty` : `${r}:value:${encodeURIComponent(t)}`;
}
function ut(e) {
  switch (e) {
    case "assignee":
      return "Unassigned";
    case "tag":
      return "Untagged";
    case "milestone":
      return "No milestone";
    case "goal":
      return "No goal";
    default:
      return "None";
  }
}
function T(e) {
  return { key: K(e, null), value: null, label: ut(e), empty: !0 };
}
function m(e, t, r) {
  const n = typeof t == "string" ? t.trim() : t == null ? "" : String(t);
  return n ? {
    key: K(e, n),
    value: n,
    label: r || ot(n),
    empty: !1
  } : T(e);
}
function z(e) {
  if (typeof e == "string") {
    const i = e.trim();
    return i ? { value: i.toLowerCase(), label: i } : null;
  }
  if (!e || typeof e != "object" || Array.isArray(e)) return null;
  const t = e, r = [t.email, t.gitEmail, t.displayName, t.gitName].find((i) => typeof i == "string" && i.trim()), n = [t.displayName, t.email, t.gitName, t.gitEmail].find((i) => typeof i == "string" && i.trim());
  return typeof r != "string" || typeof n != "string" ? null : { value: r.trim().toLowerCase(), label: n.trim() };
}
function ct(e, t) {
  return t === "milestone" ? st(e) : c.get(e)?.fields.find((r) => {
    if (!k(r)) return !1;
    const n = r.targetTrackerTypes;
    return Array.isArray(n) && n.includes("goal");
  });
}
function dt(e, t) {
  return ct(e, t)?.name ?? (t === "milestone" ? "collection" : "goal");
}
function ft(e, t) {
  const r = dt(e.primaryType, t);
  return g(e.fields[r]).filter((n) => !n.trackerType || n.trackerType === t);
}
function ue(e, t) {
  return t?.(e.itemId)?.trim() || e.title || e.issueKey || e.itemId;
}
function yt(e, t, r) {
  const i = ft(e, t).map((s) => {
    const a = ue(s, r);
    return {
      key: K(t, s.itemId),
      value: s.itemId,
      label: a,
      empty: !1
    };
  });
  return i.length > 0 ? ce(i) : [T(t)];
}
function ce(e) {
  return [...new Map(e.map((t) => [t.key, t])).values()];
}
function pt(e, t, r) {
  if (typeof t == "object") {
    const n = c.get(e.primaryType)?.fields.find((a) => a.name === t.fieldId), i = e.fields[t.fieldId];
    if (!n || n.multiValue || !["select", "boolean", "user", "relationship"].includes(n.type)) return [T(t)];
    if (n.type === "relationship") {
      const a = g(i);
      return a.length ? a.map((o) => m(t, o.itemId, ue(o, r))) : [T(t)];
    }
    if (n.type === "user") {
      const a = z(i);
      return [a ? m(t, a.value, a.label) : T(t)];
    }
    const s = n.options?.find((a) => (typeof a == "string" ? a : a.value) === String(i));
    return [m(t, i, typeof s == "object" ? s.label : void 0)];
  }
  switch (t) {
    case "status":
      return [m(t, V(e))];
    case "priority":
      return [m(t, ne(e))];
    case "type":
      return [m(
        t,
        e.primaryType,
        c.get(e.primaryType) ? lt(e.primaryType, !0) : void 0
      )];
    case "assignee": {
      const n = z(v(e, "assignee"));
      return [n ? m(t, n.value, n.label) : T(t)];
    }
    case "tag": {
      const n = v(e, "tags"), s = (Array.isArray(n) ? n : n == null ? [] : [n]).filter((a) => typeof a == "string" && !!a.trim()).map((a) => m(t, a.trim(), `#${a.trim()}`));
      return s.length > 0 ? ce(s) : [T(t)];
    }
    case "milestone":
    case "goal":
      return yt(e, t, r);
  }
}
function mt(e, t, r) {
  if (t === "none") return [{ key: "none:all", label: "All", items: e }];
  const n = /* @__PURE__ */ new Map();
  for (const s of e)
    for (const a of pt(s, t, r)) {
      const o = n.get(a.key);
      o ? o.items.push(s) : n.set(a.key, { key: a.key, label: a.label, items: [s] });
    }
  const i = [...n.values()];
  return [
    ...i.filter((s) => !s.key.endsWith(":empty")),
    ...i.filter((s) => s.key.endsWith(":empty"))
  ];
}
function gt(e) {
  return e && typeof e == "object" && "kind" in e && e.kind === "field" && "fieldId" in e && typeof e.fieldId == "string" && e.fieldId.trim() ? { kind: "field", fieldId: e.fieldId } : e === "owner" ? "assignee" : at.includes(e) ? e : "none";
}
const M = "manual", bt = "kanbanSortOrder";
function ht(e) {
  return typeof e == "string" && e.trim() ? e : M;
}
function Tt(e) {
  return e === M ? bt : e;
}
function vt(e) {
  return e !== "viewed";
}
function Un(e) {
  return e.filter((t) => t.sortable && vt(t.id));
}
function $n(e, t) {
  const r = Tt(t);
  switch (r) {
    case "type":
      return e.primaryType;
    // Sort on what the column shows, not on the raw field behind it.
    case "key":
    case "issueKey":
      return Z(e);
    case "created":
      return e.system.createdAt;
    case "updated":
    case "lastIndexed":
      return e.system.lastIndexed ?? e.system.updatedAt;
    case "module":
      return e.system.documentPath;
    case "createdBy":
      return e.system.authorIdentity;
    case "updatedBy":
      return e.system.lastModifiedBy;
    case "source":
      return e.source;
    case "shared":
      return te(e);
    default:
      return e.fields[r];
  }
}
const St = /* @__PURE__ */ new Set([
  "is-current-user",
  "is-not-current-user",
  "is-empty",
  "is-not-empty"
]), Pn = {
  "=": "is",
  "!=": "is not",
  contains: "contains",
  "not-contains": "does not contain",
  in: "is any of",
  "not-in": "is none of",
  ">": "is after / greater than",
  ">=": "is at or after",
  "<": "is before / less than",
  "<=": "is at or before",
  between: "is between",
  "in-last": "is in the last",
  "not-in-last": "is not in the last",
  "is-current-user": "is current user",
  "is-not-current-user": "is not current user",
  "is-empty": "is empty",
  "is-not-empty": "is not empty"
}, Ct = ["=", "!=", "contains", "not-contains", "is-empty", "is-not-empty"], It = ["=", "!=", "in", "not-in", "is-empty", "is-not-empty"], kt = [
  "is-current-user",
  "is-not-current-user",
  "=",
  "!=",
  "in",
  "not-in",
  "is-empty",
  "is-not-empty"
], wt = ["=", "!=", ">", ">=", "<", "<=", "between", "is-empty", "is-not-empty"], Nt = [
  "in-last",
  "not-in-last",
  "=",
  "!=",
  ">",
  ">=",
  "<",
  "<=",
  "between",
  "is-empty",
  "is-not-empty"
], At = ["=", "is-empty", "is-not-empty"], Dt = ["contains", "not-contains", "in", "is-empty", "is-not-empty"];
function Gn(e) {
  switch (e) {
    case "select":
      return It;
    case "user":
      return kt;
    case "multiselect":
    case "array":
    case "relationship":
    case "reference":
    case "citation":
      return Dt;
    case "date":
    case "datetime":
      return Nt;
    case "number":
      return wt;
    case "boolean":
      return At;
    default:
      return Ct;
  }
}
function C(e) {
  return e == null ? !0 : typeof e == "string" ? e.trim() === "" : Array.isArray(e) ? e.length === 0 : !1;
}
function de(e) {
  if (C(e)) return [];
  if (Array.isArray(e)) return e.flatMap(de);
  if (typeof e == "object") {
    const t = e, r = t.itemId ?? t.issueKey ?? t.url ?? t.email ?? t.gitEmail ?? t.gitName ?? t.displayName ?? t.title;
    return r === void 0 ? [] : [String(r)];
  }
  return [String(e)];
}
function h(e) {
  if (e instanceof Date) return e.getTime();
  if (typeof e == "number") return Number.isFinite(e) ? e : void 0;
  if (typeof e == "boolean") return Number(e);
  if (typeof e == "string") {
    const t = e.trim();
    if (t === "") return;
    const r = Number(t);
    if (Number.isFinite(r)) return r;
    const n = new Date(t);
    return Number.isNaN(n.getTime()) ? void 0 : n.getTime();
  }
}
function x(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
function R(e) {
  if (C(e)) return [];
  if (Array.isArray(e)) return e.flatMap(R);
  if (typeof e != "object") return [String(e).trim().toLowerCase()].filter(Boolean);
  const t = e;
  return [
    t.email,
    t.gitEmail,
    t.gitName,
    t.displayName
  ].filter((r) => typeof r == "string" && r.trim().length > 0).map((r) => r.trim().toLowerCase());
}
function q(e, t, r = {}) {
  const { op: n } = t;
  if (n === "is-empty") return C(e);
  if (n === "is-not-empty") return !C(e);
  if (n === "is-current-user" || n === "is-not-current-user") {
    const s = new Set(R(r.currentUser));
    if (s.size === 0) return !1;
    const a = R(e);
    if (a.length === 0) return !1;
    const o = a.some((l) => s.has(l));
    return n === "is-current-user" ? o : !o;
  }
  const i = de(e);
  switch (n) {
    case "=":
      return i.some((s) => x(s, String(t.value ?? ""))) || C(e) && C(t.value);
    case "!=":
      return !i.some((s) => x(s, String(t.value ?? "")));
    case "contains": {
      const s = String(t.value ?? "").toLowerCase();
      return i.some((a) => a.toLowerCase().includes(s));
    }
    case "not-contains": {
      const s = String(t.value ?? "").toLowerCase();
      return !i.some((a) => a.toLowerCase().includes(s));
    }
    case "in": {
      if (!Array.isArray(t.value)) return !1;
      const s = t.value.map((a) => String(a).toLowerCase());
      return i.some((a) => s.includes(a.toLowerCase()));
    }
    case "not-in": {
      if (!Array.isArray(t.value)) return !1;
      const s = t.value.map((a) => String(a).toLowerCase());
      return !i.some((a) => s.includes(a.toLowerCase()));
    }
    case ">":
    case ">=":
    case "<":
    case "<=": {
      const s = h(e), a = h(t.value);
      return s === void 0 || a === void 0 ? !1 : n === ">" ? s > a : n === ">=" ? s >= a : n === "<" ? s < a : s <= a;
    }
    case "between": {
      if (!Array.isArray(t.value) || t.value.length !== 2) return !1;
      const s = h(e), a = h(t.value[0]), o = h(t.value[1]);
      return s === void 0 || a === void 0 || o === void 0 ? !1 : s >= Math.min(a, o) && s <= Math.max(a, o);
    }
    case "in-last":
    case "not-in-last": {
      const s = h(e), a = h(t.value);
      if (a === void 0 || a < 0) return !1;
      if (s === void 0) return n === "not-in-last";
      const o = (r.nowMs ?? Date.now()) - a * 24 * 60 * 60 * 1e3, l = s >= o;
      return n === "in-last" ? l : !l;
    }
    default:
      return !1;
  }
}
function B(e) {
  return !e.field || !e.op ? !1 : St.has(e.op) ? !0 : e.op === "between" ? Array.isArray(e.value) && e.value.length === 2 : e.op === "in" || e.op === "not-in" ? Array.isArray(e.value) && e.value.length > 0 : e.value !== void 0 && e.value !== null && String(e.value) !== "";
}
function Et(e, t, r = {}) {
  const n = (e?.clauses ?? []).filter(B);
  return n.length === 0 ? !0 : (e?.combinator ?? "and") === "or" ? n.some((s) => q(t(s.field), s, r)) : n.every((s) => q(t(s.field), s, r));
}
function Ft(e, t, r, n = {}) {
  return (t?.clauses ?? []).filter(B).length === 0 ? e : e.filter((s) => Et(t, (a) => r(s, a), n));
}
function Rt(e, t) {
  return {
    combinator: e?.combinator ?? "and",
    clauses: (e?.clauses ?? []).filter((r) => r.field !== t)
  };
}
function jn(e, t, r) {
  const n = Rt(e, t);
  return { combinator: n.combinator, clauses: [...n.clauses, ...r] };
}
function Wn(e, t) {
  return (e?.clauses ?? []).filter((r) => r.field === t);
}
function Yn(e) {
  return (e?.clauses ?? []).some(B);
}
function _t(e) {
  return e === "all" || e === "closed" ? e : "open";
}
const _ = {
  list: { label: "List", icon: "view_list" },
  table: { label: "Table", icon: "table_chart" },
  kanban: { label: "Board", icon: "view_kanban" },
  timeline: { label: "Timeline", icon: "align_horizontal_left" },
  radar: { label: "Radar", icon: "radar" },
  "tag-board": { label: "Tags", icon: "sell" },
  inbox: { label: "Inbox", icon: "inbox" }
}, zn = Object.keys(_).map((e) => ({
  value: e,
  ..._[e]
}));
function Lt(e, t = "list") {
  return typeof e == "string" && e in _ ? e : t;
}
function Ot(e) {
  return Array.isArray(e) ? e.filter((t) => typeof t == "string").map((t) => t.trim()).filter(Boolean) : typeof e == "string" ? e.split(",").map((t) => t.trim()).filter(Boolean) : [];
}
function U(e) {
  return Ot(v(e, "tags"));
}
function xn(e) {
  const t = /* @__PURE__ */ new Map();
  for (const r of e) {
    const n = new Set(U(r));
    for (const i of n)
      t.set(i, (t.get(i) || 0) + 1);
  }
  return Array.from(t.entries()).map(([r, n]) => ({ name: r, count: n })).sort((r, n) => n.count !== r.count ? n.count - r.count : r.name.localeCompare(n.name));
}
function Vt(e, t) {
  if (t.length === 0) return e;
  const r = new Set(t);
  return e.filter((n) => U(n).some((i) => r.has(i)));
}
function qn(e) {
  const t = /* @__PURE__ */ new Map(), r = [];
  for (const i of e) {
    const s = Array.from(new Set(U(i)));
    if (s.length === 0) {
      r.push(i);
      continue;
    }
    for (const a of s) {
      const o = t.get(a);
      o ? o.push(i) : t.set(a, [i]);
    }
  }
  const n = Array.from(t.entries()).map(([i, s]) => ({ tag: i, label: i, items: s })).sort((i, s) => s.items.length !== i.items.length ? s.items.length - i.items.length : i.label.localeCompare(s.label));
  return r.length > 0 && n.push({ tag: null, label: "Untagged", items: r }), n;
}
const Kt = "statusChangedTo", Mt = "statusChangedFrom";
function fe() {
  return {
    selectedType: "all",
    activeFilters: [],
    viewMode: "list",
    tagFilter: [],
    groupBy: "none",
    ordering: M,
    sortBy: "lastIndexed",
    sortColumns: [],
    sortDirection: "desc",
    recentlyViewedDays: 30,
    columnConfig: null,
    columnFilters: null,
    inboxScope: null,
    statusScope: "open"
  };
}
function Hn(e) {
  const t = fe();
  return e.selectedType !== t.selectedType || e.activeFilters.length > 0 || e.tagFilter.length > 0 || e.viewMode !== t.viewMode || e.groupBy !== t.groupBy || e.ordering !== t.ordering || e.sortBy !== t.sortBy || e.sortDirection !== t.sortDirection || e.recentlyViewedDays !== t.recentlyViewedDays || e.columnConfig !== null || (e.columnFilters?.clauses.length ?? 0) > 0 || e.inboxScope === "type" || e.statusScope !== t.statusScope;
}
function Bt(e, t) {
  return e === "grid" ? "table" : Lt(e, t);
}
function Ut(e) {
  const t = fe();
  return !e || typeof e != "object" ? t : {
    selectedType: typeof e.selectedType == "string" ? e.selectedType : t.selectedType,
    activeFilters: Array.isArray(e.activeFilters) ? e.activeFilters : t.activeFilters,
    viewMode: Bt(e.viewMode, t.viewMode),
    tagFilter: Array.isArray(e.tagFilter) ? e.tagFilter.filter((r) => typeof r == "string") : t.tagFilter,
    groupBy: gt(e.groupBy ?? Pt(e.columnConfig)),
    ordering: ht(e.ordering),
    sortBy: typeof e.sortBy == "string" ? e.sortBy : t.sortBy,
    ...e.timelineFields && (typeof e.timelineFields.start == "string" || typeof e.timelineFields.end == "string") ? { timelineFields: { ...typeof e.timelineFields.start == "string" ? { start: e.timelineFields.start } : {}, ...typeof e.timelineFields.end == "string" ? { end: e.timelineFields.end } : {} } } : {},
    sortColumns: Array.isArray(e.sortColumns) ? e.sortColumns.filter((r) => r && typeof r.field == "string" && (r.direction === "asc" || r.direction === "desc")) : [],
    sortDirection: e.sortDirection === "asc" || e.sortDirection === "desc" ? e.sortDirection : t.sortDirection,
    recentlyViewedDays: e.recentlyViewedDays === null || e.recentlyViewedDays === 7 || e.recentlyViewedDays === 30 || e.recentlyViewedDays === 90 ? e.recentlyViewedDays : t.recentlyViewedDays,
    columnConfig: $t(e.columnConfig),
    columnFilters: Gt(e.columnFilters),
    inboxScope: e.inboxScope === "global" || e.inboxScope === "type" ? e.inboxScope : t.inboxScope,
    statusScope: _t(e.statusScope)
  };
}
function $t(e) {
  if (!e || typeof e != "object") return null;
  const t = e;
  return !Array.isArray(t.visibleColumns) || t.visibleColumns.length === 0 ? null : {
    visibleColumns: t.visibleColumns.filter((r) => typeof r == "string"),
    columnWidths: t.columnWidths && typeof t.columnWidths == "object" ? t.columnWidths : {},
    // Absent (or unrecognized) stays absent so the Type column resolves to its icon default.
    ...t.typeColumnDisplay === "label" || t.typeColumnDisplay === "icon" ? { typeColumnDisplay: t.typeColumnDisplay } : {}
  };
}
function Pt(e) {
  if (!(!e || typeof e != "object"))
    return e.groupBy;
}
function Gt(e) {
  if (!e || typeof e != "object") return null;
  const t = e;
  if (!Array.isArray(t.clauses)) return null;
  const r = t.clauses.filter(
    (n) => !!n && typeof n.field == "string" && typeof n.op == "string"
  );
  return { combinator: t.combinator === "or" ? "or" : "and", clauses: r };
}
function Zn(e) {
  return JSON.stringify({ name: e.name, definition: e.definition });
}
function Jn(e) {
  if (!e?.viewId || typeof e.payload != "string") return null;
  let t;
  try {
    t = JSON.parse(e.payload);
  } catch {
    return null;
  }
  if (!t || typeof t != "object" || Array.isArray(t)) return null;
  const r = t, n = typeof r.name == "string" && r.name.trim() ? r.name : null;
  return n ? {
    id: e.viewId,
    name: n,
    definition: Ut(r.definition),
    shared: !0
  } : null;
}
function Qn(e, t) {
  const r = new Set(t.map((i) => i.id));
  return [...e.filter((i) => !r.has(i.id)).map(
    (i) => i.shared ? { ...i, shared: !1 } : i
  ), ...t];
}
function jt(e) {
  const t = e.system.origin;
  return t?.kind === "external" ? t.external.providerId : "native";
}
function Wt(e, t, r = {}) {
  switch (t) {
    case "owner":
    case "assignee":
      return v(e, "assignee");
    case "favorite":
      return r.favoriteItemIds?.has(e.id) ?? !1;
    case "viewed":
      return r.viewedAtByItemId?.get(e.id);
    case Kt:
      return H(e, "to");
    case Mt:
      return H(e, "from");
    case Ae:
      return r.readinessByItemId?.get(e.id)?.state;
    case X:
      return Re(e.primaryType, (n) => e.fields[n]);
    default:
      return nt(e, t);
  }
}
function H(e, t) {
  const r = L(e.primaryType, "workflowStatus"), n = t === "to" ? "newValue" : "oldValue";
  return (e.system.activity ?? []).filter((i) => i.action === "status_changed" || i.action === "updated" && i.field === r).map((i) => i[n]).filter((i) => typeof i == "string" && i.trim().length > 0);
}
function Xn(e, t = 30) {
  return e.flatMap((r) => {
    switch (r) {
      case "mine":
        return [{ field: "owner", op: "is-current-user" }];
      case "unassigned":
        return [{ field: "owner", op: "is-empty" }];
      case "high-priority":
        return [{ field: "priority", op: "in", value: ["critical", "high"] }];
      case "favorites":
        return [{ field: "favorite", op: "=", value: !0 }];
      case "recently-viewed":
        return t === null ? [{ field: "viewed", op: "is-not-empty" }] : [{ field: "viewed", op: "in-last", value: t }];
      case "recently-edited-by-others":
        return [{ field: "updatedBy", op: "is-not-current-user" }];
      case "recently-updated":
        return [{ field: "updated", op: "in-last", value: 30 }];
      case "archived":
        return [{ field: "archived", op: "=", value: !0 }];
    }
  });
}
function Yt(e, t, r = {}) {
  let n = e;
  const i = t.statusScope ?? "all";
  if (i !== "all") {
    const o = i === "closed";
    n = n.filter((l) => Fe(l.primaryType, V(l)) === o);
  }
  if (t.activeFilters.includes("mine") && r.identity) {
    const o = r.identity;
    n = n.filter((l) => Ge(l, o));
  }
  if (t.activeFilters.includes("unassigned") && (n = n.filter((o) => !v(o, "assignee"))), t.activeFilters.includes("high-priority") && (n = n.filter((o) => {
    const l = ne(o);
    return l === "critical" || l === "high";
  })), t.activeFilters.includes("favorites")) {
    const o = r.favoriteItemIds ?? /* @__PURE__ */ new Set();
    n = n.filter((l) => o.has(l.id));
  }
  if (n = Vt(n, t.tagFilter), t.sourceFilter && t.sourceFilter.length > 0) {
    const o = new Set(t.sourceFilter);
    n = n.filter((l) => o.has(jt(l)));
  }
  const s = {
    currentUser: r.identity,
    nowMs: r.nowMs
  };
  n = Ft(
    n,
    t.columnFilters,
    (o, l) => Wt(o, l, r),
    s
  );
  const a = (o) => {
    const l = o.system.updatedAt || o.system.createdAt || o.system.lastIndexed, y = l ? new Date(l).getTime() : 0;
    return Number.isNaN(y) ? 0 : y;
  };
  if (t.activeFilters.includes("recently-updated"))
    n = [...n].sort((o, l) => a(l) - a(o)).slice(0, 50);
  else if (t.activeFilters.includes("recently-viewed")) {
    const o = r.viewedAtByItemId ?? /* @__PURE__ */ new Map(), l = t.recentlyViewedDays === void 0 ? 30 : t.recentlyViewedDays, y = l === null ? Number.NEGATIVE_INFINITY : (r.nowMs ?? Date.now()) - l * 24 * 60 * 60 * 1e3;
    n = n.filter((p) => {
      const u = o.get(p.id);
      return typeof u == "number" && Number.isFinite(u) && u >= y;
    }).sort((p, u) => (o.get(u.id) ?? 0) - (o.get(p.id) ?? 0));
  } else if (t.activeFilters.includes("recently-edited-by-others")) {
    const o = r.identity;
    if (!o) return [];
    const l = (u) => !!u && [
      u.email,
      u.gitEmail,
      u.gitName,
      u.displayName
    ].some((d) => typeof d == "string" && d.trim().length > 0), y = (u) => {
      if (l(u.system.lastModifiedBy))
        return { actor: u.system.lastModifiedBy, time: a(u) };
      const d = (u.system.activity ?? []).filter((E) => l(E.authorIdentity)).sort((E, ye) => ye.timestamp - E.timestamp)[0];
      return d ? { actor: d.authorIdentity, time: d.timestamp } : null;
    }, p = /* @__PURE__ */ new Map();
    n = n.filter((u) => {
      const d = y(u);
      return !d || Pe(d.actor, o) ? !1 : (p.set(u.id, d.time), !0);
    }), n = [...n].sort((u, d) => (p.get(d.id) ?? 0) - (p.get(u.id) ?? 0)).slice(0, 50);
  }
  return n;
}
function zt(e, t) {
  const r = t.activeFilters.includes("archived");
  return (t.columnFilters?.clauses ?? []).some((i) => i.field === "archived") ? [...e] : e.filter((i) => !!i.archived === r);
}
function er(e, t, r, n = {}) {
  const i = new Set(t), s = zt(e, r).filter((a) => i.has(a.primaryType) || a.typeTags.some((o) => i.has(o)));
  return Yt(s, r, n).length;
}
function tr(e, t) {
  return mt(e, t);
}
export {
  Yt as $,
  Ie as A,
  Jt as B,
  he as C,
  Le as D,
  Z as E,
  D as F,
  Ln as G,
  On as H,
  pt as I,
  pn as J,
  Fe as K,
  ft as L,
  M,
  T as N,
  Pn as O,
  g as P,
  vn as Q,
  Ae as R,
  Kt as S,
  Bn as T,
  St as U,
  fn as V,
  $n as W,
  ct as X,
  hn as Y,
  je as Z,
  Jn as _,
  ne as a,
  Tt as a$,
  An as a0,
  lt as a1,
  tr as a2,
  En as a3,
  yn as a4,
  se as a5,
  Dn as a6,
  Rn as a7,
  Fn as a8,
  ue as a9,
  at as aA,
  _ as aB,
  xn as aC,
  Sn as aD,
  er as aE,
  Ve as aF,
  Oe as aG,
  Vt as aH,
  cn as aI,
  H as aJ,
  un as aK,
  U as aL,
  tn as aM,
  nn as aN,
  Hn as aO,
  on as aP,
  an as aQ,
  Xn as aR,
  Qn as aS,
  _t as aT,
  Ot as aU,
  Ut as aV,
  Bt as aW,
  jt as aX,
  dt as aY,
  sn as aZ,
  rn as a_,
  In as aa,
  Yn as ab,
  jn as ac,
  Wn as ad,
  f as ae,
  Se as af,
  Tn as ag,
  mn as ah,
  Kn as ai,
  Mn as aj,
  Vn as ak,
  k as al,
  zn as am,
  Lt as an,
  qt as ao,
  Zt as ap,
  Ht as aq,
  Pe as ar,
  We as as,
  _e as at,
  bt as au,
  Xt as av,
  ve as aw,
  X as ax,
  Qt as ay,
  J as az,
  dn as b,
  Zn as b0,
  Re as b1,
  en as b2,
  ln as b3,
  bn as b4,
  v as c,
  V as d,
  _n as e,
  Mt as f,
  qn as g,
  nt as h,
  B as i,
  L as j,
  Wt as k,
  Un as l,
  ht as m,
  gt as n,
  Gn as o,
  fe as p,
  Ze as q,
  kn as r,
  wn as s,
  zt as t,
  mt as u,
  Nn as v,
  gn as w,
  Cn as x,
  Et as y,
  S as z
};
//# sourceMappingURL=trackerSavedViews-B1fUFnV-.js.map
